<!--The content below is only a placeholder and can be replaced.-->

<div class="container">
    <router-outlet></router-outlet>
</div>
<vega-loading-window></vega-loading-window>
